import { Component, inject, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ExecuteConfigurationDto } from '@api-types/dtos/execute-configuration.dto';
import { PmIconComponent } from '@libs/ui';
import { Store } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
import { ReExecuteWithLimitedDataDialogComponent } from 'demand-forecasting/components/dialogs/re-execute-with-limited-data-dialog/re-execute-with-limited-data-dialog.component';
import { ForecastVersionActions } from 'demand-forecasting/store/forecast-version/forecast-version.actions';
import { LucideRotateCcw } from '@lucide/angular';

@Component({
  selector: 'pm-execute-configuration-options',
  templateUrl: './execute-configuration-options.component.html',
  imports: [
    MatMenuItem,
    TranslateModule,
    MatProgressSpinnerModule,
    MatMenu,
    MatMenuTrigger,
    PmIconComponent,
  ],
})
export class ExecuteConfigurationOptionsComponent {
  private readonly store = inject(Store);
  private readonly dialog = inject(MatDialog);

  protected readonly RotateIcon = LucideRotateCcw;

  @Input({ required: true })
  configurationId: string;

  triggerRecalculation() {
    this.store.dispatch(
      ForecastVersionActions.createVersion({
        configurationId: this.configurationId,
        executeConfigurationDto: null,
      }),
    );
  }

  triggerRecalculationWithLimitedData() {
    const dialogRef = this.dialog.open(
      ReExecuteWithLimitedDataDialogComponent,
      {},
    );

    dialogRef.afterClosed().subscribe((executeConfigurationDto) => {
      if (executeConfigurationDto) {
        this.store.dispatch(
          ForecastVersionActions.createVersion({
            configurationId: this.configurationId,
            executeConfigurationDto,
          }),
        );
      }
    });
  }

  triggerRecalculationWithExistingModel() {
    const executeConfigurationDto: ExecuteConfigurationDto = {
      useExistingModel: true,
    };
    this.store.dispatch(
      ForecastVersionActions.createVersion({
        configurationId: this.configurationId,
        executeConfigurationDto,
      }),
    );
  }
}
